import { rem } from 'polished'
import styled from 'styled-components'

import BodyText from 'LuxKit/Typography/BodyText'
import type { ExploreItem } from 'tripPlanner/types/common'

const ReviewContainer = styled.div`
  border-left: 1px solid ${props => props.theme.palette.neutral.surface.lightForegroundAlt};
  display: flex;
  padding-left: ${rem(24)};
  flex-direction: column;
  align-items: flex-start;
  gap: ${rem(8)};
`

interface Props {
  review: Exclude<ExploreItem['reviews'], undefined>[number]
}

function ExploreReview({ review }: Props) {
  return (
    <ReviewContainer key={`${review.authorUrl}-${review.publishTime}`}>
      <BodyText variant="medium" colour="light-foreground-alt">
        {review.text}
      </BodyText>
      <BodyText variant="medium" colour="light-foreground-alt" italics>
        {review.authorName}
      </BodyText>
    </ReviewContainer>
  )
}

export default ExploreReview
